import React from "react";
import { BaseTabedPage } from "../../../../_metronic/layout/components/common/baseTabedPage";
import GroupPage from "./GroupPage";
import BaseGroupSettingPage from "./BaseGroupSettingPage";
import SubGroupPage from "./SubGroupPage";


const components = [
  { id: 1, title: "MODULES.BASEINFO.Group.FORM_TITLE", url: "/groups", tab: 'groups', component: GroupPage },
  { id: 2, title: "MODULES.BASEINFO.SubGroup.FORM_TITLE", url: "/subgroups", tab: 'subgroups', component: SubGroupPage },
  // { id: 3, title: "MODULES.BASEINFO.GROUPSETTING", tab: 'groupSetting', component: <BaseGroupSettingPage key={3} /> },
];

export const GroupBasePage = () => {
  return (
    <BaseTabedPage components={components} basePath="/groups" />
  );
}
